<template lang="pug">
    v-dialog(
        v-model="_show"
        fullscreen
    )
        v-toolbar(
            :color="colors.primary"
            dark
            )
            .d-flex.align-center.justify-space-between(style="width: 100%;")
                h2(style="width: 80%;") Seleccione una cuenta
                v-btn(
                    :color="colors.secondary"
                    style="width: 200px;"
                    @click="_show = false"
                    )
                    v-icon(left) arrow_back
                    span volver
        v-card
            v-treeview.ma-3(
                :items="tree"
                item-text="text"
                )
                template(slot="prepend" slot-scope="props")
                    v-btn(
                        icon
                        @click="selectAccount(props.item.id)"
                        v-if="[3,4].includes(props.item.level)"
                        )
                        v-icon(:color="colors.secondary") send
</template>

<script>
export default {
    name: 'account-tree-picker',
    props: {
        /**
         * @description
         */
        show: {
            type: Boolean,
            default: () => true,
        },
        /**
         * @description
         */
        accounts: {
            type: Array,
            default: () => [],
        },
        /**
         * @description
         */
        accountTypes: {
            type: Array,
            default: () => [],
        },
        idx: {
            type: Number,
        },
    },
    data: function() {
        return {
            root: [
                {
                    code: '1.00.00.00',
                    text: '1 - Total Activos',
                    children: [],
                },
                {
                    code: '2.00.00.00',
                    text: '2 - Total Pasivos',
                    children: [],
                },
                {
                    code: '3.00.00.00',
                    text: '3 - Estado de Resultados',
                    children: [],
                },
            ],
        }
    },
    computed: {
        /**
         * @description
         */
        _show: {
            get: function() {
                return this.show
            },
            set: function(val) {
                this.$emit('show', val)
            },
        },
        tree: function() {
            return this.createTree()
        },
    },
    methods: {
        // Most structure from inner to outer lvl in tree structure
        createTree: function() {
            let childrenAcc = []
            let parentAcc = []
            let accounts = this.accounts
            let level3 = this.nestChildrenAccountById(
                this.filterAccounts(accounts),
                'acc_parent_id',
                4
            )
            let types = this.accountTypes.map(this.formatAccount)
            let level2 = this.nestChildrenAccountById(
                { parentAccounts: types, childrenAccounts: level3 },
                'acc_account_type_id',
                3
            )
            let rtt = this.root
            let level1 = this.nestChildrenByCode(
                { parent: rtt, children: level2 },
                this.matchCodes,
                2
            )
            return level1
        },
        nestChildrenByCode: function(obj, condition, level = 0) {
            let parent = [...obj.parent]
            let children = [...obj.children]
            let nested = []
            parent.forEach((p, i) => {
                if (!p.children) p.children = []
                p.level = level - 1
                nested[i] = p
                children.forEach((c, j) => {
                    if (condition(p, c)) {
                        c.level = level
                        nested[i].children.push(c)
                    }
                })
            })
            return nested
        },
        matchCodes: function(obj1, obj2) {
            if (obj1.code.charAt(0) === obj2.code.charAt(0)) return true
            return false
        },
        test(e) {
            console.log(e)
        },
        filterAccounts: function(accounts) {
            let parentAccounts = []
            let childrenAccounts = []
            accounts.forEach(account => {
                account = this.formatAccount(account)
                if (!account.acc_parent_id) {
                    parentAccounts.push(account)
                } else {
                    childrenAccounts.push(account)
                }
            })
            return { parentAccounts, childrenAccounts }
        },
        formatAccount: function(account) {
            let { id, code, comment, acc_parent_id } = account
            let acc = { ...account }
            acc.text = `${code} - ${comment}`
            if (!acc_parent_id) {
                acc.children = []
            }
            return acc
        },
        nestChildrenAccountById: function(obj, id, level = 0) {
            let parentAccounts = [...obj.parentAccounts]
            let childrenAccounts = [...obj.childrenAccounts]
            let nested = []
            parentAccounts.forEach((acc, i) => {
                nested[i] = acc
                acc.level = level - 1
                childrenAccounts.forEach((child, j) => {
                    if (child[id] === nested[i].id) {
                        child.level = level
                        nested[i].children.push(child)
                    }
                })
            })
            return nested
        },
        selectAccount: function(id) {
            this.$emit('account:select', id)
            this._show = false
        },
    },
    watch: {},
    components: {},
    mixins: [],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    // mounted: function(){...},
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
</style>